import { render } from "./CustomerOrdersList.vue?vue&type=template&id=3ff535c4&scoped=true&ts=true&lang=pug"
import script from "./CustomerOrdersList.vue?vue&type=script&lang=ts"
export * from "./CustomerOrdersList.vue?vue&type=script&lang=ts"

import "./CustomerOrdersList.vue?vue&type=style&index=0&id=3ff535c4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff535c4"]])

export default __exports__